import Layout from '../views/layout/Layout'

export default {
  path: '/ums',
  component: Layout,
  redirect: '/ums/admin',
  name: 'ums',
  meta: {title: '权限管理', icon: 'ums'},
  children: [
    {
      path: 'admin',
      name: 'admin',
      component: () => import('@/views/ums/admin/index'),
      meta: {title: '用户列表', icon: 'ums-admin'}
    },
    {
      path: 'resert',
      name: 'resert',
      component: () => import('@/views/ums/admin/resertPassword'),
      meta: {title: '修改密码', icon: 'ums-admin'},
    },
    {
      path: 'update',
      name: 'update',
      component: () => import('@/views/ums/admin/updatePwd'),
      meta: {title: '设置密码', icon: 'ums-admin'},
      hidden: true
    },
    {
      path: 'role',
      name: 'role',
      component: () => import('@/views/ums/roles/index'),
      meta: {title: '角色列表', icon: 'ums-role'}
    },
    {
      path: 'allocMenu',
      name: 'allocMenu',
      component: () => import('@/views/ums/roles/allocMenu'),
      meta: {title: '分配菜单'},
      hidden: true
    },

    {
      path: 'menu',
      name: 'menu',
      component: () => import('@/views/ums/menus/index'),
      meta: {title: '菜单列表', icon: 'ums-menu'}
    },
    {
      path: 'addMenu',
      name: 'addMenu',
      component: () => import('@/views/ums/menus/add'),
      meta: {title: '添加菜单'},
      hidden: true
    }
  ]
}


// WEBPACK FOOTER //
// ./src/router/ums.js